<template>
  <div class="form-builder assignment">
    <md-card class="assignment-card">
      <md-card-content>
        <div v-if="learnersOptions.length != 0">
          <h2>1. Assign {{ activityTitle }}</h2>
          <div class="assignment-section">
            <md-field :class="{'md-invalid': !this.valid && this.titleError}">
              <label>Title</label>
              <md-input v-model="title"></md-input>
              <span class="md-error">*Give your {{ assignmentLabel.toLowerCase() }} a title.</span>
            </md-field>
            <fb-rich-text
              :mode="true"
              v-model="description"
              :uuid="$uuid.v1()"
              :element="{data: {value: description}}"
              editor_format="client_full_html"
            />
          </div>
          <h2>2. Assign to Learners</h2>
          <div class="assignment-section">

            <md-field
              class="fb-select assignment-learner-select"
              :class="{'md-invalid': !this.valid && this.learnerError}"
            >
              <md-select
                ref="learnersSelect"
                placeholder="- Select Learners -"
                @md-selected="resetAllIfCount"
                @md-closed="resetAll"
                @md-opened="setAllClick"
                id="select-view"
                v-model="learners"
                :multiple="true"
              >
                <md-option
                  @click.native="setAllLearners(1)"
                  ref="learnersOption"
                  value="all"
                >All Learners</md-option>
                <md-option
                  :key="learner.uuid"
                  v-for="learner in learnersOptions"
                  :value="learner.uuid"
                >
                  {{learner.name}}
                </md-option>
              </md-select>
              <span class="md-helper-text"></span>
            </md-field>
            <md-field
              v-if="!this.valid && this.learnerError"
              :class="{'md-invalid': !this.valid && this.learnerError}"
              class="label-top"
            >
              <span class="md-error">*Select which learner(s) should receive this.</span>
            </md-field>
          </div>
          <h2>3. Set Learner Submission Requirements</h2>
          <div class="assignment-section">
            <div class="assignment-date">
              <md-datepicker md-immediately v-model="date" :required="true">
                <label>Select Due Date (optional)</label>
                <span class="md-helper-text"></span>
                <span class="md-error">*Please fill date.</span>
              </md-datepicker>
            </div>
          </div>
          <div class="md-layout-item md-layout md-alignment-center-center">
            <md-button v-if="showSaveDraft" class="md-button" @click="save">Save Draft</md-button>
            <md-button class="md-primary" @click="start">Save & Send</md-button>
          </div>
        </div>
        <div v-else class="md-layout">
          <h3>You do not have any learners assigned.</h3>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import HelpersMixin from "./HelpersMixin";
import Spinner from "./components/Spinner.vue";

export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate", "editMode"],
  mixins: [HelpersMixin],
  computed: {
    valid() {
      if (!this.validate) {
        return true;
      }
      if (this.isDraft) {
        return this.title && this.title != "";
      }
      return this.title && this.title != "" && this.learners.length;
    },
    titleError() {
      return !this.title || this.title == "";
    },
    learnerError() {
      if (!this.isDraft) {
        return this.learners.length == 0;
      }
      return false;
    },
  },
  data() {
    return {
      //submissionUuid: window.drupalSettings.assigned.uuid,
      uuid: null,
      isDraft: window.drupalSettings.hasOwnProperty('assigned') ?
        !!+window.drupalSettings.assigned.is_draft : 1,
      showSaveDraft: window.drupalSettings.hasOwnProperty('assigned') ?
        !!+window.drupalSettings.assigned.is_draft : 1,
      validate: false,
      learner: null,
      learners: [],
      learnersOptions: window.drupalSettings.user.learners || [],
      date: null,
      //menuOpen: false,
      //showLoader: false,
      description: (window.drupalSettings.assigned && window.drupalSettings.assigned.description) || "",
      title: (window.drupalSettings.assigned && window.drupalSettings.assigned.title) ||
        (window.drupalSettings.assigned && window.drupalSettings.assigned.activity_title),
      nuuid: (window.drupalSettings.assigned && window.drupalSettings.assigned.activity) || "",
      cleanError: false,
      assignmentLabel: window.drupalSettings.group_catch_config.labels.assignment_label || "Assignment",
      activityTitle: (window.drupalSettings.assigned && window.drupalSettings.assigned.activity_title) || "",
      activityId: (window.drupalSettings.assigned && window.drupalSettings.assigned.activity_id) || null,
    };
  },
  components: {
    Spinner
  },
  mounted() {
    this.$material.locale.dateFormat = "MM/dd/yyyy";
    if (this.editMode) {
      this.uuid = window.drupalSettings.assigned.uuid;
      this.nuuid = window.drupalSettings.assigned.activity;
      let withData = false;
      this.learners = window.drupalSettings.assigned.learners
        ? Object.keys(window.drupalSettings.assigned.learners).map((key) => {
          let submission = this.getLearnerSubmission(key);
          if (submission.data) {
            withData = true;
          }
          return key;
        })
        : [];

      this.description = window.drupalSettings.assigned.description;
      this.title = window.drupalSettings.assigned.title;
      this.date = window.drupalSettings.assigned.due_date
        ? this.$moment(
          window.drupalSettings.assigned.due_date,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY")
        : null;
      this.submission_required =
        window.drupalSettings.assigned.submission_required == 1;
      if (withData) {
        this.submission_required = true;
        this.submission_required_disabled = true;
      }

    }
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    getLearnerSubmission(uuid) {
      if (!window.drupalSettings.assigned.submissions) {
        return false;
      }
      let submissions = Object.keys(
        window.drupalSettings.assigned.submissions
      ).filter((submissionId) => {
        let submission =
          window.drupalSettings.assigned.submissions[submissionId];
        return submission.learner.uuid == uuid;
      });
      if (submissions.length) {
        return window.drupalSettings.assigned.submissions[submissions[0]];
      }
      return false;
    },
    resetAllIfCount() {
      let all = this.learners.indexOf("all");
      if (
        (this.learners.length == 1 && all === 0) ||
        event.target ==
        this.$refs["learnersOption"].$el.querySelector(
          ".md-checkbox-container"
        )
      ) {
        return;
      }
      if (
        all !== -1 &&
        this.learners.length - 1 != this.learnersOptions.length
      ) {
        this.learners.splice(all, 1);
      }
    },
    resetAll() {
      let all = this.learners.indexOf("all");
      if (all !== -1) {
        this.learners.splice(all, 1);
      }
    },
    setAllLearners(reverse) {
      let all = this.learners.indexOf("all");
      if (reverse && all !== -1) {
        this.learners = ["all"].concat(
          this.learnersOptions.map((el) => {
            return el.uuid;
          })
        );
      } else if (reverse) {
        this.learners = this.learnersOptions
        .filter((learner) => {
          return this.getLearnerSubmission(learner.uuid).data;
        })
        .map((learner) => {
          return learner.uuid;
        });
      }
    },
    setAllClick() {
      if (this.learners.length == this.learnersOptions.length) {
        this.learners.push("all");
      }
      this.$refs["learnersSelect"].$el;
      this.$refs["learnersOption"].$el
      .querySelector(".md-checkbox-container")
      .addEventListener("click", () => {
        this.setAllLearners(1);
        event.preventDefault();
      });
    },
    updateError(value) {
      this.cleanError = value;
    },
    save() {
      this.validate = true;
      this.isDraft = true;
      if (!this.valid) {
        return;
      }
      this.showLoader = true;
      return this.sendAssignedRequest(true, false)
      .then(() => {
        localStorage.setItem("assignment_message_action", "draft");
        localStorage.setItem("assignment_message_title", this.title);
        if (this.editMode) {
          window.location.href = "/assignments";
          //this.showLoader = false;
          //window.location.reload();
          //return;
        }
        else {
          window.location.href = "/node/" + this.activityId;
        }
      })
      .catch((e) => {
        this.showLoader = false;
        // TODO: Add error you page
        throw new Error(e);
      });
    },
    start() {
      this.isDraft = false;
      this.validate = true;
      if (!this.valid) {
        return;
      }
      this.showLoader = true;
      return this.sendAssignedRequest(false, true)
      .then(() => {
        localStorage.setItem("assignment_message_action", "save");
        localStorage.setItem("assignment_message_title", this.title);
        if (this.editMode) {
          window.location.href = "/assignments";
          //this.showLoader = false;
          //window.location.reload();
          //return;
        }
        else {
          window.location.href = "/node/" + this.activityId;
        }
      })
      .catch((e) => {
        this.showLoader = false;
        // TODO: Add error you page
        throw new Error(e);
      });
    },
    sendAssignedRequest(isDraft, isStarted) {
      let self = this;

      return self.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let method = "POST";
        if (self.editMode) {
          method = "PATCH";
        }
        let value = {
          date: self.date,
        };
        value.isDraft = isDraft;
        value.isStarted = isStarted;
        let a_data = {
          data: {
            type: "assigned--assigned",
            attributes: {
              is_draft: isDraft,
              due_date: self.date
                ? self.$moment(self.date).format("YYYY-MM-DD")
                : null,
              description: self.description,
              title: self.title,
            },
            relationships: {
              learner:
                self.learners.length === 0
                  ? null
                  : {
                    data: self.learners.map((learner) => {
                      return {
                        type: "user--user",
                        id: learner,
                      };
                    }),
                  },
              activity: {
                data: {
                  type: "node--activity",
                  id: self.nuuid,
                },
              },
            },
          },
        };
        let url = "/jsonapi/assigned/assigned";
        if (this.editMode) {
          url += "/" + self.uuid;
          a_data.data.id = self.uuid;
        }
        return fetch(url, {
          credentials: "include",
          method: method,
          headers: fetch_headers,
          body: JSON.stringify(a_data),
        })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json && json.errors && json.errors.length) {
            throw new Error(json.errors[0].title);
          }
          return json;
        });
      });
    },
  },
};
</script>
<style lang="scss">
.assignment {
  font-size: 16px;
  font-weight: normal;
  p {
    font-size: 16px;
    font-weight: normal;
  }
  .upload-link {
    flex-direction: row-reverse;
    display: flex;
    align-items: flex-start;
    .md-button:first-child {
      margin-right: auto !important;
    }
  }
  h1 {
    font-size: 36px;
    line-height: 54px;
    color: $title-blue;
    text-align: left;
    margin-top: 0px;
  }
  .assignment-card {
    padding: 0px;
    .md-card-content {
      padding: 24px;
    }
    h2:first-child {
      margin-top: 0;
    }
  }
  .assignment-section {
    padding-left: 20px;
    padding-right: 20px;
  }
  h2 {
    color: rgb(60, 60, 60);
    font-family: $font-filson-soft;
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    text-align: left;
  }
  .assignment-learner-select,
  .assignment-date {
    max-width: 300px;
  }
}
</style>
